<template>
    <div class="outer">
        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="创建(出库)时间" prop="rqScopeArr">
                    <el-date-picker v-model="queryForm.rqScopeArr" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="onSearch"
                        @clear="onSearch">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table v-loading="loading" border class="table" :row-style="{ height: '50px' }"
            style="width: 100%;height: 68vh;overflow: auto;" :data="tableData">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="出库单号" prop="outNo">
            </el-table-column>
            <el-table-column align="center" label="货物名称" prop="goodsName">
            </el-table-column>
            <el-table-column align="center" label="数量" prop="goodsNum">
            </el-table-column>
            <el-table-column align="center" label="申领单号" prop="applyNo">
                <template slot-scope="scope">
                    <el-button type="text"@click="goApplyOut(scope.row)">{{  scope.row.applyNo }}</el-button>
                </template>
            </el-table-column>
            <el-table-column align="center" label="接收人名称" prop="receiverUserName">
            </el-table-column>
            <el-table-column align="center" label="创建人" prop="createUserName">
            </el-table-column>
            <el-table-column align="center" label="创建时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { queryOutStoreList } from '@/api/goods/inventory.js';
export default {
    data() {
        return {
            loading: false,
            total: 0, // 总条数
            tableData: [], // 表格数据
            queryForm: {
                page: 1,
                limit: 10,
                flag: 1,
            }
        }
    },
    components: {
    },
    created() {
        this.queryOutStoreList();
    },
    computed: {
    },
    methods: {
        goApplyOut(row){
            this.$router.push({
                name: '行政货物申领',
                params: {
                    applyNo: row.applyNo
                }
            })
        },
        queryOutStoreList() {
            this.loading = true;
            queryOutStoreList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.total = res.count;
                }
                this.loading = false;
            })
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.queryOutStoreList();
        },
        // 搜索
        onSearch() {
            if (this.queryForm.rqScopeArr) {
                this.queryForm.rqScope = this.queryForm.rqScopeArr.join(',');
            }else{
                this.queryForm.rqScope = '';
            }
            this.queryForm.page = 1;
            this.queryOutStoreList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.queryOutStoreList();
        },
    }
}
</script>
<style lang="scss" scoped>
.outer {

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-table {
        ::v-deep .warning-row {
            display: none;
        }
    }

    .table {

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
